import React, { useState, useEffect } from "react";
import ThemeSwitch from "./ThemeSwitch";
import Etherium from "./Etherium";
import ProfileOption from "./ProfileOption";
import ErrorDisplay from "./../../component/reusable/ErrorDisplay3";
import { useConnectWallet } from "@web3-onboard/react";


export default function NavBar({
  isDarkMode,
  setIsDarkMode,
  netWroks,
  setNetWroks,
}) {
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const [isConnected, setIsConnected] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  useEffect(() => {
    if (!isOnline) { setIsErrorVisible(true) }
    else { setIsErrorVisible(false) }

  }, [isOnline])
  const handleCloseError = () => {
    setIsErrorVisible(false);
    setErrorMessage("");
  };
  const handleReload = () => {
    window.location.reload();
  }
  useEffect(() => {
    try {
      if (wallet) {
        if (wallet?.accounts[0]?.address) setIsConnected(true);
      } else {
        setIsConnected(false);
      }
    } catch (error) {
      // console.log(error)
    }
  });

  return (
    <div className="flex justify-end gap-2 ">
      <div
        className="bg-sunny-secondary dark:bg-dark-secondary rounded-lg p-1 flex items-center"
      >
        <ThemeSwitch isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
      </div>

      {isConnected &&
        <div className="bg-sunny-secondary dark:bg-dark-secondary rounded-lg p-1 flex items-center">
          <Etherium networks={netWroks} setNetworks={setNetWroks} />
        </div>
      }

      {isConnected && (
        <div className="bg-sunny-secondary dark:bg-dark-secondary rounded-lg p-1 flex items-center">
          <ProfileOption />
        </div>
      )}

      {!isConnected && (
        <div>
          <button
            style={{ paddingLeft: 40, paddingRight: 40 }}
            className="flex w-full flex-row items-center justify-start gap-3 px-[12px] py-[7px] transition-[background] duration-300 ui-open:bg-white/20 ui-not-open:bg-transparent ui-not-open:hover:bg-white/20 sm:w-max rounded border px-2 py-1 border-gray-1 ui-not-open:bg-gray-1 ui-not-open:hover:bg-white/10"
            type="button"
            aria-label="Account Header Button"
            aria-expanded="false"
            onClick={() => connect()}
          >
            <span className="flex flex-col text-justify text-base leading-extra-tight text-gray-4 sm:text-green">
              CONNECT WALLET
            </span>
          </button>
        </div>
      )}
      {isErrorVisible && (
        <ErrorDisplay
          message={errorMessage}
          onClose={handleCloseError}
          handleReload={handleReload}
        />
      )}
    </div>
  );
}
